export default {
    "home": {
        "title": "Home",
        "title_manage": "Home - Gestão",
        "title_map": "Home - Mapa"
    },
    "global_types": {
        "titles": "Tipos - Globais",
        "title": "Tipo - Global",
        "list": {
            "name": "Nome",
            "order": "Ordem",
        },
        "model": {
            "name": "Nome",
            "order": "Ordem"
        },
        "form": {
            "relationship": "Itens para relacionamento"
        },
        "help": {
            "order": "Ordem de apresentação no painel dos filtros",
        }
    },
    "global_statuses": {
        "titles": "Estados - Globais",
        "title": "Estado Global",
        "list": {
            "order": "Ordem",
            "name": "Nome",
            "color": "Côr",
        },
        "model": {
            "description": "Nome",
            "order": "Ordem",
            "color": "Côr",
        },
        "form": {
            "relationship": "Itens para relacionamento"
        },
        "help": {
            "order": "Ordem de apresentação no painel dos filtros",
        }
    },
    "settings": {
        "titles": "Configurações",
        "page_title": "Configurações globais do módulo",
    },
    "types": {
        "titles": "Tipos Obra",
        "title": "Tipo Obra",
    },
    "unities": {
        "titles": "Unidades",
        "title": "Unidade",
    },
    "parish_interventions_home": {
        "title": "Mapa - Obras Freguesia",
    },
    "parish_interventions_home_manage": {
        "title": "Gestão - Obras Freguesia",
    },
    "parish_interventions_unities": {
        "titles": "@:unities.titles",
        "title": "@:unities.title",
        "form": {
            "placeholder_user": "Utilizador...",
            "add_user": "Adicionar",
            "delete_user": "Deseja remover o utilizador <u>{name}</u>?",
            "user_not_found": "Sem utilizadores associados",
            "tabs" : {
                "general": "Geral",
                "parishes": "Freguesias",
                "users": "Utilizadores"
            },
        },
        "model": {
            "name": "Nome",
            "email": "E-mail",
            "phone": "Telemóvel",
            "status": "Estado",
            "users" : {
                "name": "Nome",
                "email": "E-mail",
            }
        },
        "msg": {
            "no-parish": "Sem freguesias associadas"
        }
    },
    "parish_interventions_statuses": {
        "titles": "Estados",
        "title": "Estado",
        "model": {
            "name": "Nome",
            "order": "Ordem",
            "color": "Côr",
            "status": "Estado",
            "mark": "Pin",
            "last_process": "Último processo",
            "first_process": "Primeiro processo",
        }
    },
    "parish_interventions_types": {
        "titles": "@:types.titles",
        "title": "@:types.title",
        "form": {
            "group_delete": "Deseja remover o grupo <u>{name}</u>?",
        },
        "model": {
            "name": "Nome",
            "icon": "Icon",
            "parent": "Grupo",
            "order": "Ordem",
            "status": "Estado",
        },
    },
    "parish_interventions_claimants": {
        "titles": "Requerentes",
        "title": "Requerente",
        "model": {
            "name": "Nome",
            "status": "Estado",
        },
    },
    "parish_interventions_contract_types": {
        "titles": "Tipos Contrato",
        "title": "Tipo Contrato",
        "model": {
            "name": "Nome",
            "status": "Estado",
        },
    },
    "parish_interventions_procedure_types": {
        "titles": "Tipos Procedimento",
        "title": "Tipo Procedimento",
        "model": {
            "name": "Nome",
            "status": "Estado",
        },
    },
    "parish_interventions_reports": {
        "titles": "Fichas Obra",
        "title": "Ficha Obra",
        "model": {
            "name": "Nome",
            "status": "Estado",
            "page_title": "Título de Impressão",
            "div_title": "Sub-Título de Impressão",
            "map_title": "Título do Mapa",
            "scale": "Escala",
            "dpi": "DPI",
            "crs": "CRS (ex: EPSG:3763)",
            "comment": "Comentário",
            "flex_scale": "Ajustável",
        },
        "form": {
            "layers": "Temas (Layers)",
            "add": "Adicionar",
            "add_cross": "Adicionar cruzamento",
            "field_name": "Campo para Nome",
            "field_descr": "Campo para Descrição",
        },
        "help": {
            "settings": "Incluir dados do elemento",
        }
    },
    "parish_interventions_notifications": {
        "titles": "@:notifications.titles",
        "title": "@:notifications.title",
        "model": {
            "automatic": "@:notifications.model.automatic",
            "channel_id": "@:notifications.model.channel_id",
            "channel_id_abbr": "@:notifications.model.channel_id_abbr",
            "name": "@:notifications.model.name",
            "subject": "@:notifications.model.subject",
            "message": "@:notifications.model.message",
            "triggers": "@:notifications.model.triggers",
            "tags": "@:notifications.model.tags",
            "targets": "@:notifications.model.targets",
            "targets_abbr": "@:notifications.model.targets_abbr",
            "status": "@:notifications.model.status"
        },
        "form": {
            "msg": {
                "help": "Mensagem a ser enviada",
            }
        }
    },
    "parish_interventions_global_statuses": {
        "model": {
            "description": "@:global_statuses.model.description",
            "order": "@:global_statuses.model.order",
            "color": "@:global_statuses.model.color",
        },
        "form": {
            "relationship": "@:global_statuses.form.relationship"
        },
        "help": {
            "order": "@:global_statuses.help.order",
        }
    },
    "parish_interventions_global_types": {
        "model": {
            "name": "@:global_types.model.name",
            "order": "@:global_types.model.order",
        },
        "form": {
            "relationship": "@:global_types.form.relationship",
        },
        "help": {
            "order": "@:global_types.help.order",
        }
    },
    "municipal_interventions_home": {
        "title": "Gestão - Intervenções Municipais",
    },
    "municipal_interventions_statuses": {
        "titles": "Estados",
        "title": "Estado",
        "model": {
            "name": "Nome",
            "order": "Ordem",
            "color": "Côr",
            "status": "Estado",
            "mark": "Pin",
            "last_process": "Último processo",
            "first_process": "Primeiro processo",
        }
    },
    "municipal_interventions_types": {
        "titles": "@:types.titles",
        "title": "@:types.title",
        "model": {
            "name": "Nome",
            "order": "Ordem",
            "status": "Estado",
        },
    },
    "municipal_interventions_service_typologies": {
        "titles": "Tipologia de Serviços",
        "title": "Tipologia de Serviço",
        "model": {
            "name": "Nome",
            "description": "Descrição",
            "status": "Estado",
        },
    },
    "municipal_interventions_unities": {
        "titles": "@:unities.titles",
        "title": "@:unities.title",
        "form": {
            "placeholder_user": "Utilizador...",
            "add_user": "Adicionar",
            "delete_user": "Deseja remover o utilizador <u>{name}</u>?",
            "user_not_found": "Sem utilizadores associados",
            "tabs" : {
                "general": "Geral",
                "parishes": "Freguesias",
                "users": "Utilizadores"
            },
        },
        "model": {
            "name": "Nome",
            "email": "E-mail",
            "phone": "Telemóvel",
            "status": "Estado",
            "users" : {
                "name": "Nome",
                "email": "E-mail",
            }
        }
    },
    "municipal_interventions_reports": {
        "titles": "Fichas de obra",
        "title": "Ficha de obra",
        "model": {
            "name": "Nome",
            "status": "Estado",
            "page_title": "Título de Impressão",
            "div_title": "Sub-Título de Impressão",
            "map_title": "Título do Mapa",
            "scale": "Escala",
            "dpi": "DPI",
            "crs": "CRS (ex: EPSG:3763)",
            "comment": "Comentário",
            "flex_scale": "Ajustável",
        },
        "form": {
            "layers": "Temas (Layers)",
            "add": "Adicionar",
            "add_cross": "Adicionar cruzamento",
            "field_name": "Campo para Nome",
            "field_descr": "Campo para Descrição",
        },
        "help": {
            "settings": "Incluir dados do elemento",
        }
    },
    "municipal_interventions_global_statuses": {
        "model": {
            "description": "@:global_statuses.model.description",
            "order": "@:global_statuses.model.order",
            "color": "@:global_statuses.model.color",
        },
        "form": {
            "relationship": "@:global_statuses.form.relationship"
        },
        "help": {
            "order": "@:global_statuses.help.order",
        }
    },
    "municipal_interventions_global_types": {
        "model": {
            "name": "@:global_types.model.name",
            "order": "@:global_types.model.order",
        },
        "form": {
            "relationship": "@:global_types.form.relationship",
        },
        "help": {
            "order": "@:global_types.help.order",
        }
    },
}
